var $ = global.$;

require('../third-party/mousewheel.min.js');
require('../third-party/mCustomScrollbar.js');

var velocity = require('velocity-animate');
var uiBlock = require('global/ui-block');

var _Base = require('./_Base');

var Navigation = _Base.extend({
  init: function() {
    var self = this;
    this.$navToggle = $('[data-navigation-toggle]');
    this.$navToggleIcon = this.$navToggle.find('.icon');
    this.$navMenu = $('[data-navigation-menu]');

    this.$navItems = $('[data-navigation-item]');

    this.$scrollArea = $('.navigation__scroll');

    this.$subNavToggles = $('[data-submenu-toggle]');
    this.qlClosed = true;

    self.detectMobile();

    this.classes = {
      menuOpen: 'is-open',
      menuOpenMobile: 'is-expanded',
      menuIcon: 'icon--menu',
      closeIcon: 'icon--close',
      expandIcon: 'icon--plus',
      contractIcon: 'icon--minus'
    };

    this.close();

    this.$el.on('Quicklinks:opened', function() {
      if (self.qlClosed) {
        self.$navMenu.css({
          zIndex: '103'
        });
        self.qlClosed = false;
      }
    });

    this.$el.on('Quicklinks:closed', function() {
      self.$navMenu.css({
        zIndex: '101'
      });
      self.qlClosed = true;
    });

    this.$scrollArea.mCustomScrollbar({
      theme: 'light',
      autoHideScrollbar: true,
      scrollInertia: 400,
      contentTouchScroll: 100
    });

    this.$navToggle.on('click', function(event) {
      event.preventDefault();
      self._navToggleClickHandler.call(self);
    });

    this.$navItems.on('mouseenter', function(event) {
      var that = this;
      if (!self.isMobile) {
        that.open = true;
        event.preventDefault();
        self.$navItems.one('mouseleave', function(event) {
          that.open = false;
          if ($(this).hasClass(self.classes.menuOpen)) self.closeSubMenu($(this));
        });
        setTimeout(function() {
          if (that.open) {
            if (!$(that).hasClass(self.classes.menuOpen)) self.openSubMenu($(that));
          }
        }, 100);
      }
    });

    this.$navItems.on('focusin', function(event) {
      var $parent = $(this);
      if (!self.isMobile && !$parent.hasClass(self.classes.menuOpen)) {
        self.closeSubMenus($parent);
        self.openSubMenu($parent);
      }
    });

    $(document).on('focusin', function(event) {
      if ($(event.target).closest(self.$navItems).length === 0) {
        self.closeSubMenus();
      }
    });

    this.$subNavToggles.on('click', function(event) {
      event.preventDefault();
      self._subMenuToggleClickHandler.call(self, this);
    });

    $(window).on('resize orientationchange', function() {
      self.detectMobile();
    });
  },

  detectMobile: function() {
    this.isMobile = this.$navToggle.is(':visible');
  },

  _navToggleClickHandler: function() {
    return this.isOpen ? this.close() : this.open();
  },

  _subMenuToggleClickHandler: function(item) {
    var $item = $(item);
    var $parent = $item.parents('[data-navigation-item]');
    return $parent.hasClass(this.classes.menuOpenMobile) ? this.closeSubMenuMobile($parent) : this.openSubMenuMobile($parent);
  },

  _navItemHoverHandler: function(item) {
    var $hoveredItem = $(item);

    return $hoveredItem.hasClass(this.classes.menuOpen) ? this.closeSubMenu($hoveredItem) : this.openSubMenu($hoveredItem);
  },

  openSubMenu: function($item) {
    var $submenu = $item.find('[data-submenu]');
    this.$navItems.removeClass(this.classes.menuOpen);
    $item.addClass(this.classes.menuOpen);
    $submenu.velocity('fadeIn');
  },

  closeSubMenu: function($item,duration) {
    var self = this;
    var $submenu = $item.find('[data-submenu]');
    if ($submenu.length > 0) {
      $submenu.velocity('fadeOut', {
        duration: duration ? duration : 100,
        complete: function() {
          $item.removeClass(self.classes.menuOpen);
        }
      });
    } else {
      $item.removeClass(self.classes.menuOpen);
    }
  },

  closeSubMenus: function($exclude) {
    var self = this;
    this.$navItems.each(function(){
      if ($exclude && $exclude[0] !== this && $(this).hasClass(self.classes.menuOpen)) {
        self.closeSubMenu($(this),0);
      } else if (!$exclude && $(this).hasClass(self.classes.menuOpen)) {
        self.closeSubMenu($(this),0);
      }
    });
  },

  openSubMenuMobile: function($item) {
    var $submenu = $item.find('[data-submenu]');
    var $icon = $item.find('.icon');
    $item.addClass(this.classes.menuOpenMobile);
    $icon.addClass(this.classes.contractIcon);
    $icon.removeClass(this.classes.expandIcon);
    $submenu.velocity('slideDown');
  },

  closeSubMenuMobile: function($item) {
    var $submenu = $item.find('[data-submenu]');
    var $icon = $item.find('.icon');
    $item.removeClass(this.classes.menuOpenMobile);
    $icon.addClass(this.classes.expandIcon);
    $icon.removeClass(this.classes.contractIcon);
    $submenu.velocity('slideUp');
  },

  open: function() {
    uiBlock.block();
    this.$navToggle.addClass(this.classes.menuOpen);
    setTimeout(function() {
      this.$navToggleIcon.removeClass(this.classes.menuIcon);
      this.$navToggleIcon.addClass(this.classes.closeIcon);
    }.bind(this), 100);
    this.$navMenu.velocity({
      'scale': '1',
      'opacity': '1'
    }, {
      'display': 'block',
      duration: 300,
      complete: function() {
        var svg = this.$el.find('svg').eq(0);
        var svgParent = svg.parents().eq(0);
        svg.detach();
        svgParent.append(svg);
        this.$el.addClass(this.classes.menuOpen);

      }.bind(this)
    });
    this.isOpen = true;
  },

  close: function() {
    var self = this;
    this.$el.removeClass(this.classes.menuOpen);
    this.$navToggleIcon.removeClass(this.classes.closeIcon);
    this.$navToggleIcon.addClass(this.classes.menuIcon);
    self.$navToggle.removeClass(self.classes.menuOpen);
    this.$navMenu.velocity({
      'scale': '0'
    }, {
      easing: 'EaseOutSine',
      'display': 'none',
      duration: 300
    });
    uiBlock.unblock();
    this.isOpen = false;
  }
});

module.exports = Navigation;



//////////////////
// WEBPACK FOOTER
// ./source/scripts/widgets/Navigation.js
// module id = 17
// module chunks = 0 1